import { createAction } from 'redux-actions';

export const setInitialTeamOpen = createAction('SET_INITIAL_TEAM_OPEN');
export const toggleTeamOpen = createAction('TOGGLE_TEAM_OPEN');
export const openAllTeams = createAction('openAllTeams');
